import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Inicio', href: '#inicio' },
    { name: 'Sobre mí', href: '#sobre-mi' },
    { name: 'Servicios', href: '#servicios' },
    { name: 'Trayectoria', href: '#trayectoria' },
    { name: 'Testimonios', href: '#testimonios' },
    { name: 'Contacto', href: '#contacto' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#fffef2]/95 backdrop-blur-sm border-b border-[#ebeade]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#inicio" onClick={(e) => scrollToSection(e, '#inicio')} className="flex flex-col">
            <span className="text-xl font-medium text-[#333333] tracking-tight">Javier Blanco Rojo</span>
            <span className="text-xs text-[#666666] tracking-wider uppercase">Empresario Inmobiliario</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-sm text-[#333333] hover:text-[#1a365d] transition-colors duration-200 relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#1a365d] transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+34673361681"
              className="flex items-center gap-2 px-6 py-3 bg-transparent border border-[#1a365d] text-[#1a365d] text-sm font-medium hover:bg-[#1a365d] hover:text-white transition-all duration-200"
            >
              <Phone className="w-4 h-4" />
              673 361 681
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-[#333333]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[#ebeade]">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-sm text-[#333333] hover:text-[#1a365d] transition-colors py-2"
                >
                  {link.name}
                </a>
              ))}
              <a
                href="tel:+34673361681"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-[#1a365d] text-white text-sm font-medium mt-4"
              >
                <Phone className="w-4 h-4" />
                673 361 681
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
